import profileImage from "../assets/img/avatars/profileImage.jpg";
import { handleRequestAction } from "actions/actions";
import { toast } from "react-toastify";
import ContractInfo from "../components/ContractInfo.jsx";
import ImageModal from "../components/imageModel/imageMode.jsx";
import { useState } from "react";

const BASE_URL = process.env.REACT_APP_ENDPOINT;

const RequetsColumn = (refetch) => [
  {
    Header: "اسم المقاول",
    accessor: "name",
    Cell: ({ row }) => {
      const [isModalOpen, setIsModalOpen] = useState(false);

      const handleImageClick = () => {
        setIsModalOpen(true);
      };

      const handleCloseModal = () => {
        setIsModalOpen(false);
      };

      return (
        <div className="flex min-w-[140px] items-center gap-3">
          <img
            src={
              row.original.photo
                ? `${BASE_URL}/${row.original?.photo}`
                : profileImage
            }
            alt="avatar"
            className="h-10 w-10 rounded-full border border-gray-200"
            crossOrigin="anonymous"
            onClick={handleImageClick}
          />
          {isModalOpen && (
            <ImageModal
              src={
                row.original.photo
                  ? `${BASE_URL}/${row.original?.photo}`
                  : profileImage
              }
              onClose={handleCloseModal}
            />
          )}
          <span className="font-medium">{row.original.name || "—"}</span>
        </div>
      );
    },
  },
  {
    Header: "رقم الهاتف",
    accessor: "phoneNumber",
  },

  {
    Header: "الحالة",
    accessor: "active",
    Cell: ({ row }) => {
      return (
        <span
          className={`rounded-full px-2 py-1 text-xs ${
            row.values.active
              ? "bg-green-500 text-white"
              : "bg-red-500 text-white"
          }`}
        >
          {row.values.active ? "مفعل" : "غير مفعل"}
        </span>
      );
    },
  },
  {
    Header: "العقد",
    accessor: "contractorInfo",
    Cell: ({ row }) => {
      return <ContractInfo contractor={row.values.contractorInfo} />;
    },
  },
  {
    Header: "إجراء",
    accessor: "id",
    Cell: ({ row }) => {
      return (
        <div className="flex  items-start gap-2">
          <button
            className=" rounded-full bg-green-500 px-6 py-1 text-white transition-all hover:bg-green-600 disabled:cursor-not-allowed disabled:bg-gray-300 disabled:text-gray-400"
            onClick={() =>
              handleRequestAction(row.original.id, "accepted").then((res) => {
                if (res.error) {
                  toast.error(res.error);
                } else {
                  toast.success(res.success);
                  refetch();
                }
              })
            }
            disabled={
              row.original.status === "accepted" ||
              row.original.status === "rejected"
            }
          >
            قبول
          </button>

          <button
            className=" rounded-full bg-red-500 px-6 py-1 text-white transition-all hover:bg-red-600 disabled:cursor-not-allowed disabled:bg-gray-300 disabled:text-gray-400"
            onClick={() =>
              handleRequestAction(row.original.id, "reject").then((res) => {
                if (res.error) {
                  toast.error(res.error);
                } else {
                  toast.success(res.success);
                  refetch();
                }
              })
            }
            disabled={
              row.original.status === "accepted" ||
              row.original.status === "rejected"
            }
          >
            رفض
          </button>
        </div>
      );
    },
  },
];

export default RequetsColumn;
